export enum ACTION_TYPE {
JOURNEY_UPDATE = 1,
JOURNEY_SHARE = 2,
JOURNEY_DELETE = 3,
CONTEXT_ADD = 4,
CONTEXT_UPDATE = 5,
CONTEXT_SHARE = 6,
CONTEXT_DELETE = 7,
COMMENT_ADD = 8,
COMMENT_UPDATE = 9,
COMMENT_DELETE = 10,
COMMENT_MENTION = 11,
TASK_CREATE = 12,
TASK_UPDATE = 13,
TASK_DELETE = 14,
TASK_COMMENT_ADD = 15,
TASK_ASSIGNEE_ADD= 16,
REQUEST_ACCESS=17,
APPROVE_REQUEST_ACCESS=18,
DENY_REQUEST_ACCESS=19,
KPI_SUBSCRIBE = 20,
JOURNEY_COMMENT = 21,
JOURNEY_COMMENT_DELETE = 23,
PP_Job_Update = 25,
REPL_SUMMARY = 26,
EXCEPTION_DATA = 27,
KPI_SHARE = 28,
SIMULATE_SELL_IN = 29,
DEFAULT_ADD = 30,
STORE_TRANSFER_JOB_STATUS = 31,
CLASS_PREDICTION_JOB = 32,
APPROVE_REQUEST = 33,
APPROVAL_RESPONSE = 34,
STORETRANSFER_EXPORT = 35,
MASTER_EXPORT_REPORT = 36,
PUSH_ORDER_JOB = 42,
JOURNEY_COLL_DEL = 38,
SIMULATE_CONSTRAINED = 39,
REPL_PLANNER_EXPORT = 40,
IMPORT_POG = 41,
UPDATE_GROUPS = 43,
REPL_PLANNER_CALC_JOB = 44,
PlannerCopyMeasureAsync = 46,
FBForecastCommitAsync = 47,

}
export enum ButtonType {
    ADD,
    REFRESH,
    EXPORT,
    UPLOAD,
    COMMIT,
    DELETE,
    SYNC,
    SAVE,
    EXPAND,
    COLLAPSE,
    Toggle
  }
